import { render } from "./BlogListView.vue?vue&type=template&id=810a6354&scoped=true"
import script from "./BlogListView.vue?vue&type=script&lang=js"
export * from "./BlogListView.vue?vue&type=script&lang=js"

import "./BlogListView.vue?vue&type=style&index=0&id=810a6354&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-810a6354"]])

export default __exports__